import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage1 from '../assets/images/desc/bg-stage1.jpg'
import backgroundImage2 from '../assets/images/desc/bg-stage2.png'
import startBtnImage from '../assets/images/desc/start.png';
import yellowDrone from '../assets/images/drone-game/drone-yellow.png';
import redDrone from '../assets/images/drone-game/drone-red.png';
import blueDrone from '../assets/images/drone-game/drone-blue.png';

const drones = [ yellowDrone, redDrone, blueDrone ]

class Desc extends Component {

    btnSound = './sounds/button_sound.mp3';

    constructor(props) {
        super(props);
        this.state = { 
            droneImage: drones[this.props.location.state.droneIndex],
            stageIndex: this.props.location.state.stageIndex
        }
    }
    
    goToGamePage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: this.state.stageIndex === 0 ? './drone' : './attack',
            state: {
                selectedIndex: this.props.location.state.droneIndex
            }
        });
    };

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={this.state.stageIndex === 0 ? backgroundImage1 : backgroundImage2} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' src={this.state.droneImage} style={{ width: '17%', position: 'absolute', left: '10.5%', top: '30%' }}></img>
                <img className='press-btn' alt='' src={startBtnImage} style={{ height: '12%', bottom: '4%', left: '38.5%', position: 'absolute', background: 'transparent' }} onClick={this.goToGamePage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(Desc);
